// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"styles_modalOverlay__1G0L_","CloseButton":"styles_CloseButton__1jASq","modal":"styles_modal__1vXRj","white":"styles_white__3d_kH"};